/* ══════════════════════════════════════════════════════════════════
   Felix & Lassie — configurateur de la colonne d'achat
   ══════════════════════════════════════════════════════════════════

   Transforme la colonne d'achat en parcours à étapes : le client prend
   une décision à la fois, au lieu de tout voir d'un coup.

   ─── LE PRINCIPE DE SÛRETÉ ──────────────────────────────────────
   Les étapes sont masquées PAR CE SCRIPT, jamais dans le Liquid.

   Conséquence : si ce fichier ne charge pas, ne s'exécute pas, ou
   plante, TOUTES les étapes restent visibles et la page redevient une
   colonne d'achat linéaire — qui fonctionne. La vente passe toujours.

   C'est le seul garde-fou qui rend le configurateur acceptable : sans
   lui, une erreur JS rendrait la page inachetable.

   ─── CE QUI EST INTERDIT ICI ────────────────────────────────────
   Toucher au bouton « Ajouter au panier ». Il n'est jamais désactivé,
   jamais grisé, quel que soit l'état du parcours. Aucune ligne de ce
   fichier ne doit poser `disabled` dessus.
   ══════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var SEL = '[data-fl-configurateur]';
  var ETAPE = '[data-fl-etape]';

  function init(racine) {
    var etapes = Array.prototype.slice.call(racine.querySelectorAll(ETAPE));
    if (etapes.length < 2) return; // rien à orchestrer

    var courante = 0;
    // Le stepper vit HORS de la carte, juste au-dessus : on le cherche
    // dans le document, pas seulement dans la racine.
    var stepper = racine.querySelector('[data-fl-stepper]')
                || document.querySelector('[data-fl-stepper]');
    var suivant = racine.querySelector('[data-fl-suivant]');
    // Horizon rend le bloc d'achat dans un <span class="buy-buttons-block">.
    // On vise le conteneur, pas le <button> : masquer le seul bouton
    // laisserait la quantité et les paiements express visibles.
    var achat = racine.querySelector('.buy-buttons-block, [data-fl-achat]');
    var retour = racine.querySelector('[data-fl-retour]');

    // ── Affichage ────────────────────────────────────────────────
    function afficher(i) {
      courante = Math.max(0, Math.min(i, etapes.length - 1));

      etapes.forEach(function (el, n) {
        el.hidden = n !== courante;
      });

      // Le picker suit l'étape, en un seul morceau. On le DÉPLACE plutôt
      // que d'en extraire les fieldsets : déplacer l'élément entier
      // préserve ses écouteurs et sa lecture interne des inputs, donc le
      // prix continue de se mettre à jour.
      if (picker && groupes.length && courante < groupes.length) {
        if (etapes[courante] && picker.parentNode !== etapes[courante]) {
          etapes[courante].appendChild(picker);
        }
        picker.hidden = false;
        afficherOption(courante);
      } else if (picker) {
        picker.hidden = true;
      }

      if (stepper) {
        Array.prototype.forEach.call(
          stepper.querySelectorAll('[data-fl-pas]'),
          function (pas, n) {
            pas.classList.toggle('is-actif', n === courante);
            pas.classList.toggle('is-fait', n < courante);
            pas.setAttribute('aria-current', n === courante ? 'step' : 'false');
          }
        );
      }

      var dernier = courante === etapes.length - 1;

      if (suivant) {
        // On ne change QUE la visibilité. Jamais l'état activé/désactivé.
        suivant.hidden = dernier;
      }

      // Le bouton d'achat n'apparaît qu'à la dernière étape — c'est le
      // parcours voulu. Il n'est JAMAIS désactivé : on joue sur `hidden`,
      // jamais sur `disabled` (non-négociable n°1). Si ce script ne
      // s'exécute pas, le bouton reste visible et la vente passe.
      if (achat) achat.hidden = !dernier;

      // Le retour arrière est toujours possible.
      if (retour) retour.hidden = courante === 0;

      // Le focus suit l'étape, pour les lecteurs d'écran et le clavier.
      var titre = etapes[courante].querySelector('[data-fl-titre-etape]');
      if (titre && document.activeElement !== document.body) {
        titre.setAttribute('tabindex', '-1');
        titre.focus({ preventScroll: true });
      }
    }

    // ── Navigation ───────────────────────────────────────────────
    if (suivant) {
      suivant.addEventListener('click', function (e) {
        e.preventDefault();
        afficher(courante + 1);
      });
    }

    if (retour) {
      retour.addEventListener('click', function (e) {
        e.preventDefault();
        afficher(courante - 1);
      });
    }

    // Le stepper est cliquable : le retour arrière est toujours possible.
    if (stepper) {
      stepper.addEventListener('click', function (e) {
        var pas = e.target.closest('[data-fl-pas]');
        if (!pas) return;
        var n = parseInt(pas.getAttribute('data-fl-pas'), 10);
        if (!isNaN(n)) afficher(n);
      });
    }

    // ── Avance automatique au choix d'une option ─────────────────
    // Horizon pose data-fieldset-index sur chaque input du picker.
    // Choisir un support (index 0) fait passer à la taille (index 1).
    racine.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.type !== 'radio') return;

      var idx = input.getAttribute('data-fieldset-index');
      if (idx === null) return;

      var n = parseInt(idx, 10);
      if (isNaN(n)) return;

      // Petit délai : laisse Horizon mettre à jour le prix et la galerie
      // avant de changer d'étape, sinon le client voit l'ancien prix.
      window.setTimeout(function () {
        if (n === courante && courante < etapes.length - 1) {
          afficher(courante + 1);
        }
      }, 260);
    });

    // ── Une option de variante par étape ─────────────────────────
    // Le variant picker rend toutes les options d'un coup, et le
    // template ne peut pas le scinder.
    //
    // ⚠️ NE JAMAIS sortir les fieldsets de <variant-picker>. Il écoute
    // « change » sur lui-même et relit ses inputs par this.querySelectorAll :
    // déplacés ailleurs, ses radios ne le préviennent plus, il n'émet plus
    // productSelect, et le PRIX N'EST JAMAIS MIS À JOUR — le bug du 02/09,
    // où choisir un encadré à 104,90 € laissait 59,90 € affiché.
    //
    // On masque donc les fieldsets un à un, sans les déplacer, et le
    // picker reste intact. L'ordre vient de l'admin Shopify (option 1 =
    // Support), pas d'ici : c'est ce qui rend « support avant taille »
    // gratuit côté code.
    var picker = racine.querySelector('variant-picker');
    var groupes = [];
    if (picker) {
      // Un <fieldset> par option. data-fieldset-index est porté par le
      // fieldset lui-même ou par un de ses descendants selon le style de
      // picker (boutons ou menu déroulant) : on part du fieldset, qui est
      // l'unité fiable, et on lit l'index où qu'il soit.
      Array.prototype.forEach.call(
        picker.querySelectorAll('fieldset'),
        function (bloc, rang) {
          var porteur = bloc.hasAttribute('data-fieldset-index')
                      ? bloc
                      : bloc.querySelector('[data-fieldset-index]');
          var idx = porteur
                  ? parseInt(porteur.getAttribute('data-fieldset-index'), 10)
                  : rang;
          if (isNaN(idx)) idx = rang;
          if (!groupes[idx]) groupes[idx] = bloc;
        }
      );
    }

    // Le picker vit dans la première étape ; les étapes suivantes qui
    // correspondent à une option restent vides côté template et sont
    // remplies visuellement par ce masquage.
    function afficherOption(n) {
      groupes.forEach(function (g, i) {
        if (g) g.hidden = i !== n;
      });
    }

    // Horizon REMPLACE le contenu du picker à chaque changement de
    // variant : les fieldsets sont recréés, et le masquage est perdu —
    // les deux options réapparaissaient d'un coup après un choix de
    // taille. On observe donc le picker et on réapplique.
    if (picker && window.MutationObserver) {
      var enCours = false;
      new MutationObserver(function () {
        if (enCours) return;
        enCours = true;
        window.setTimeout(function () {
          groupes = [];
          Array.prototype.forEach.call(
            picker.querySelectorAll('fieldset'),
            function (bloc, rang) {
              var porteur = bloc.hasAttribute('data-fieldset-index')
                          ? bloc
                          : bloc.querySelector('[data-fieldset-index]');
              var idx = porteur
                      ? parseInt(porteur.getAttribute('data-fieldset-index'), 10)
                      : rang;
              if (isNaN(idx)) idx = rang;
              if (!groupes[idx]) groupes[idx] = bloc;
            }
          );
          if (courante < groupes.length) afficherOption(courante);
          if (typeof reparerCombinaison === 'function') reparerCombinaison();
          enCours = false;
        }, 60);
      }).observe(picker, { childList: true, subtree: true });
    }

    // ── L'échappatoire reste lisible ─────────────────────────────
    // L'uploader vit DANS l'étape « SA PHOTO », comme la maquette le
    // prévoit. Mais son lien « je l'envoie après la commande » porte le
    // non-négociable n°2 : il doit rester visible et rassurant. On le
    // laisse donc en place et on vérifie seulement qu'il n'a pas été
    // masqué par erreur — jamais on ne le déplace hors du parcours.
    var apres = racine.querySelector('[data-fl-apres]');
    if (apres && apres.hidden) apres.hidden = false;

    // ── Jamais de cul-de-sac après un choix ──────────────────────
    // Toutes les combinaisons n'existent pas : il n'y a pas d'encadré
    // carré, donc choisir « Encadré noir » alors que « 25 × 25 cm » est
    // coché menait droit à « Non disponible(s) », prix vide, bouton
    // grisé — sans que la cliente ait rien fait de mal.
    //
    // On rattrape en basculant vers la première taille réellement
    // disponible. Horizon marque l'indisponibilité par
    // data-option-available="false" sur le radio concerné.
    function reparerCombinaison() {
      // Deux symptômes du même problème :
      //  - une option explicitement marquée indisponible reste cochée
      //  - ou aucun variant n'est résolu (champ id vide), ce qui arrive
      //    quand Horizon ne trouve pas la combinaison et n'émet donc
      //    aucune réécriture du picker
      var coche = racine.querySelector(
        'input[type="radio"]:checked[data-option-available="false"]'
      );

      if (!coche) {
        var champId = document.querySelector(
          'input[name="id"], select[name="id"]'
        );
        if (champId && champId.value) return;   // tout va bien

        // Aucun variant résolu. On corrige la SECONDE option — la
        // taille — et jamais la première : le client vient de choisir
        // son support, le lui reprendre serait pire que le problème.
        // Horizon expose data-fieldset-index : 0 = support, 1 = taille.
        // (Deux versions précédentes se fiaient à l'ordre des clés ou
        // à l'absence de data-variant-id, et annulaient le support.)
        coche = racine.querySelector(
          'input[type="radio"]:checked[data-fieldset-index="1"]'
        );
        if (!coche) return;
      }

      // On prend la première taille qui porte un data-variant-id.
      //
      // ⚠️ Ne PAS se fier à data-option-available : quand aucun variant
      // n'est résolu, Horizon ne recalcule pas les disponibilités et
      // laisse « true » partout, y compris sur la combinaison qui n'existe
      // pas. C'est data-variant-id qui dit la vérité — il est vide sur
      // l'option fautive et renseigné sur les valides.
      var candidats = racine.querySelectorAll(
        'input[type="radio"][name="' + coche.name + '"]'
      );
      for (var i = 0; i < candidats.length; i++) {
        var c = candidats[i];
        if (c === coche) continue;
        if (c.getAttribute('data-option-available') === 'false') continue;
        if (!c.getAttribute('data-variant-id')) continue;
        c.click();
        return;
      }
    }

    // La réparation doit aussi partir d'un simple `change`. Le
    // MutationObserver ne suffit pas : quand la combinaison choisie
    // n'existe pas, Horizon ne trouve aucun variant, ne réécrit donc
    // pas le picker — et l'observateur ne se déclenche jamais. Le
    // client restait alors bloqué sur un prix figé et un bouton grisé.
    racine.addEventListener('change', function (e) {
      if (!e.target || e.target.type !== 'radio') return;
      window.setTimeout(reparerCombinaison, 400);
    });

    // ── Les combinaisons impossibles ne sont pas cliquables ──────
    // Toutes les combinaisons Support × Taille n'existent pas (pas
    // d'encadré carré en gamme européenne). Horizon marque ces options
    // aria-disabled mais les laisse cliquables : le client tombait sur
    // « Non disponible(s) », prix vide, bouton grisé.
    //
    // Le CSS les barre ; ici on bloque le clic, en capture, pour que
    // rien n'atteigne le picker. Le libellé reste focusable au clavier :
    // l'information « ce format n'existe pas dans ce support » doit
    // rester annonçable aux lecteurs d'écran.
    racine.addEventListener('click', function (e) {
      var champ = e.target.closest
        ? e.target.closest('input[aria-disabled="true"], [aria-disabled="true"] input')
        : null;
      if (champ) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    // ── Démarrage ────────────────────────────────────────────────
    // C'est ICI que les étapes deviennent masquées, et nulle part ailleurs.
    racine.setAttribute('data-fl-actif', 'true');
    afficher(0);
  }

  function demarrer() {
    Array.prototype.forEach.call(document.querySelectorAll(SEL), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  // Le thème réinjecte la section produit au changement de variant.
  document.addEventListener('shopify:section:load', demarrer);
})();
